import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import BookForm from '@/components/forms/book-form'
import { Header } from '@/components/header'
import { Icons } from '@/components/icons'

export const Route = createFileRoute('/_home/zone-settings/books-zone/add')({
  component: AddBooksPage,
})

export function AddBooksPage() {
  const [showBookZoneModal, setShowBookZoneModal] =
    React.useState<boolean>(false)
  return (
    <main>
      <Button
        onClick={() => {
          if (!validateUserAddPermission()) return
          setShowBookZoneModal(!showBookZoneModal)
        }}
      >
        <Icons.add />
        Add Book Zone
      </Button>
      <Credenza open={showBookZoneModal} onOpenChange={setShowBookZoneModal}>
        <CredenzaContent className="w-full md:min-w-[600px]">
          <CredenzaTitle>
            <Header>Add Book Zone</Header>
          </CredenzaTitle>
          <hr />
          <CredenzaBody>
            <BookForm setShowBookZoneModal={setShowBookZoneModal} />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
